export const readLocalStorageJson = (key, fallback = null) => {
  if (typeof window === 'undefined') return fallback

  const storedValue = window.localStorage.getItem(key)
  if (storedValue === null) return fallback

  try {
    return JSON.parse(storedValue)
  } catch {
    window.localStorage.removeItem(key)
    return fallback
  }
}

export const getStoredUser = () => readLocalStorageJson('userData')
